import { render, staticRenderFns } from "./CreateAuthorization.vue?vue&type=template&id=25bdeb64"
import script from "./CreateAuthorization.vue?vue&type=script&lang=js"
export * from "./CreateAuthorization.vue?vue&type=script&lang=js"
import style0 from "./CreateAuthorization.vue?vue&type=style&index=0&id=25bdeb64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports